module.exports = __webpack_public_path__ + "static/media/AllWorkoutTypes_Small.20ed0eab.png";